// File type definitions for ad materials upload

export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.svg', '.tiff', '.gif'] as const
export const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov'] as const
export const DOCUMENT_EXTENSIONS = ['.pdf', '.txt', '.docx', '.odt'] as const

export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/svg+xml',
  'image/tiff',
  'image/gif',
] as const

export const VIDEO_MIME_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'] as const

export const DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'text/plain',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
] as const

// Combined arrays for accept attribute
export const ALL_EXTENSIONS = [
  ...IMAGE_EXTENSIONS,
  ...VIDEO_EXTENSIONS,
  ...DOCUMENT_EXTENSIONS,
] as const

export const ALL_MIME_TYPES = [
  ...IMAGE_MIME_TYPES,
  ...VIDEO_MIME_TYPES,
  ...DOCUMENT_MIME_TYPES,
] as const

// Generate accept attribute string
export const getAcceptAttribute = (): string => {
  return [...ALL_EXTENSIONS, ...ALL_MIME_TYPES].join(',')
}

// Check if file is an image
export const isImageFile = (url: string): boolean => {
  const lowerUrl = url.toLowerCase()
  // Remove query parameters before checking extension
  const urlWithoutQuery = lowerUrl.split('?')[0]
  return IMAGE_EXTENSIONS.some((ext) => urlWithoutQuery.endsWith(ext))
}

// Check if file is a video
export const isVideoFile = (url: string): boolean => {
  const lowerUrl = url.toLowerCase()
  // Remove query parameters before checking extension
  const urlWithoutQuery = lowerUrl.split('?')[0]
  return VIDEO_EXTENSIONS.some((ext) => urlWithoutQuery.endsWith(ext))
}

// Check if file is a PDF
export const isPdfFile = (url: string): boolean => {
  const lowerUrl = url.toLowerCase()
  const urlWithoutQuery = lowerUrl.split('?')[0]
  return urlWithoutQuery.endsWith('.pdf')
}

// Check if file is a document
export const isDocumentFile = (url: string): boolean => {
  const lowerUrl = url.toLowerCase()
  // Remove query parameters before checking extension
  const urlWithoutQuery = lowerUrl.split('?')[0]
  return DOCUMENT_EXTENSIONS.some((ext) => urlWithoutQuery.endsWith(ext))
}

// Get file type category
export type FileCategory = 'image' | 'video' | 'document' | 'unknown'

export const getFileCategory = (url: string): FileCategory => {
  if (isImageFile(url)) return 'image'
  if (isVideoFile(url)) return 'video'
  if (isDocumentFile(url)) return 'document'
  return 'unknown'
}
